import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';
import { H2 } from 'components/core/Typography';
import { IconText } from 'components/core/IconText';

import { storageList } from './PLPHowItWorksSectionOptions';
import selfStorageImage from 'assets/images/plp/self-storage.svg';
import boatStorageImage from 'assets/images/plp/boat-storage.svg';

import './PLPHowItWorksSection.scss';


function PLPHowItWorksSection({ pageType }) {
	return (
		<div className="section-content" id='how-it-works'>
			<div className="plp-how-it-works">
				<div className="background-container">
					<Image 
						src={pageType === 'Self-Storage' ? selfStorageImage : boatStorageImage}
						className="background-img"
						alt="illustration"
						lazyLoad={true}/>
				</div>
				<div>
					<H2 weight="ultraBold" color="black" className="plp-section-title" >
						How it Works
					</H2>
					<ul>
						{storageList(pageType).map((item) => (
							<li key={item.text}>
								<IconText
									key={`option-${item.text}`}
									src={item.icon}
									size="small"
									weight="standard"
									color="gray"
									last
									alt={item.alt}
								>
									{item.text}
								</IconText>
							</li>
						))}
					</ul>
				</div>
			</div>

		</div>
	);
}

PLPHowItWorksSection.propTypes = {
	pageType: PropTypes.string
};

export default PLPHowItWorksSection;
